import React from 'react';
import useForm from '../../hooks/formHook.js';
import "../../styles/LandingResetPassword.css";

export default function LandingResetPassword() {
    const { formData, handleChange } = useForm({
        email: ''
    });
    return (
        <div className="LandingResetPassword form">
            <h1>Reset Password <span role="img" aria-label="key" className={navigator.platform.startsWith("Win") && 'emoji-flip'}>🔑</span></h1>
            <form onSubmit={(e) => e.preventDefault()}>
                <input 
                aria-labelledby="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email address" />
                <input 
                type="submit"
                value="Send Reset Link" />
            </form>
        </div>
    )
}